import React from "react";

export default function MySQL_SUBSTRING() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SUBSTRING</h1>
      <p>This is the MySQL_SUBSTRING component generated from the SQL JSON.</p>
    </div>
  );
}
